<template>
   <div class="flats-section-cards-container" v-if="salesCardFlatsDefault != null">
	   <!-- <div class="container"> -->
			<!-- CARD -->
			<div class="land-flat-cards-items" :class="{'flat-cards-grid-view': gridView, 'flat-cards-list-view': !gridView}">
				<!-- навигация ячеик таблицы при виде карточек лист -->
				<div class="flat-cards-items-list-info" v-if="!gridView">
					<ul>
						<li><p>{{salesCardPage.land_flats_cards_info.flat_plan_title}}</p></li>
						<li><p>{{salesCardPage.land_flats_cards_info.flat}}</p></li>
						<li><p>{{salesCardPage.land_flats_cards_info.size}}<span>м²</span></p></li>
					</ul>
				</div>
				<!-- end -->
				<!-- карточка планировки когда стоит режим listTable -->
				<div class="flat-card-table-element" v-if="!gridView">
					<div class="flat-card" v-for="(card, index) in salesCardFlats"  :key="index" :data-id="card.room" @click="settingDataFlatsCardModal(card)">
						<div class="card-img">
							<img :src="card.flat_img" alt="">
							<div class="card-table-list-img" v-if="!gridView">
								<img :src="card.flat_img" alt="">
							</div>
						</div>
						<div class="card-info">
							<div class="col">
								<h3>{{card.room}}{{card.type}}</h3>
							</div>
							<div class="col">
								<h3>{{card.size}}</h3>
							</div>
						</div>
					</div>
				</div>
				<!-- end -->
				<!-- карточка планировки когда стоит режим GRID -->
				<swiper :options="swiperOption" class="flats-card-swiper-carousel" ref="FlatSwiperCard"  id="FlatSwiperCard" :class="{visible: gridView}">
					<swiper-slide v-for="(card, index) in salesCardFlats"  :key="index">
						<div class="flat-card flat-card-kohota" :data-id="card.room" @click="settingDataFlatsCardModal(card)" v-if="animateCards">
							<div class="card-img">
								<img :src="card.flat_img" alt="">
							</div>
							<div class="card-info card-info-kohota">
                                <div class="col">
                                    <h3>{{card.room}}{{card.type}}</h3>
									<small>{{salesCardPage.land_flats_cards_info.flat}}</small>
                                </div>
                                <div class="col">
                                    <h3>{{card.size}}</h3>
									<small>{{salesCardPage.land_flats_cards_info.size}}<span>м²</span></small>
                                </div>
							</div>
						</div>
					</swiper-slide>
				</swiper>
				<div class="swiper-controls swiper-controls-sales-land-flats" :class="{'visible': gridView}">
					<div class="flats-cards-prev-slide slider-btn slider-btn-prev"><svg-icon icon-class="left-arrow" className="icon icon-left-arrow"/></div>
					<div class="flats-cards-next-slide slider-btn slider-btn-next"><svg-icon icon-class="right-arrow" className="icon icon-right-arrow"/></div>
				</div>
				<!-- end -->
				<!-- модалка планировки -->
				<modal name="sales_land_flat-card-modal" @opened="FlatCardModalOpened" @closed="FlatCardModalClosed" :transition="transitionName" :width="modalWidth" :height="modalHeight" :scrollable="modalScroll" id="sales_land_flat_card_modal_window_info" v-if="modalData != null">
					<flatModal :config="[{active: formActive, mobile: mobile}]"></flatModal>
				</modal>
				<!-- end -->
			</div>
	   <!-- </div> -->
   </div>
</template>

<script>
	// import formFields from '@/components/forms/form-flat.vue';
	// import formMail from '@/components/forms/form-mail.vue';	
	// import flatFilter from '@/components/flats/flat-filter.vue';	
    import flatModal from '@/components/sales-land-partials/partials/kohota-flats-partials/flat-modal.vue'
	import {mapGetters} from 'vuex'
	export default {
		name: 'Cards',
		components: {
			// formFields,
			// formMail,
			// flatFilter,
			flatModal
		},
		data () {
			return {
				modalWidth: 1000,
				modalHeight: 640,
				modalScroll: false,
				formActive: false,
				mobile: false,
				transitionName: '',
				swiperActiveIndex: 1,
				countIndex: '',
				swiperOption: {
					slidesPerView: 3,
					spaceBetween: 15,
					// slidesPerColumn: 1,
					// slidesPerColumnFill: 'row',
					simulateTouch: false,
					speed: 600,
					observer: true,
					observeSlideChildren: true,
					observeParents: true,
					// pagination: {
                    //     el: '.flats-cards-pagination',
                    //     type: 'fraction',
                    // },
					navigation: {
						nextEl: '.flats-cards-next-slide',
						prevEl: '.flats-cards-prev-slide',
					},
					breakpoints: {
						768: {
							slidesPerView: 1,
							spaceBetween: 10
						},
						812: {
							slidesPerView: 2,
							spaceBetween: 10
						},
						1024: {
							slidesPerView: 3,
							spaceBetween: 10
						}
					}
				},
			}
		},
		computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            salesCardFlats: 'loadFlatsCardsGlobal',
            salesCardFlatsDefault: 'loadFlatsCardsGlobalDefault',
			gridView: 'loadLandFlatsGridView',
			animateCards: 'loadSalesLandCardAnimate',
			modalData: 'loadSalesLandModalDataArr',
        }),
		methods: {
			PushAllCards() {
				// this.$store.commit('cardAll', this.cards);
				// this.$store.commit('defaultCountCards', this.cardAll);
				this.$store.commit('modalData', this.salesCardFlatsDefault[0]);
			},
			settingDataFlatsCardModal(arr) {
				console.log(arr)
				this.$store.commit('modalData', arr);
				this.$modal.show('sales_land_flat-card-modal');
				// this.$store.commit('Open_Form_Modal', false);
				// document.getElementById('secret-btns').classList.remove('fadeIn');
			},
			FlatCardModalClosed() {
				this.formActive = false;
				window.body.removeClass('overflowTrue');
				// document.getElementById('secret-btns').classList.remove('hideAll');
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('landNav').classList.remove('notvisibleSalesLand');
                document.getElementById('banerTopHorizont').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
			},
			FlatCardModalOpened() {
				window.Sharer.init();
				window.body.addClass('overflowTrue');
				// document.getElementById('secret-btns').classList.add('hideAll');
				document.getElementById('header').classList.add('notvisibleSalesLand');
                document.getElementById('landNav').classList.add('notvisibleSalesLand');
                document.getElementById('banerTopHorizont').classList.add('notvisibleSalesLand');
                document.getElementById('footer').classList.add('notvisibleSalesLand');
			},
			checkMobileDevices() {
				var _self = this;
				if ($(window).width() <= 1024) {
					_self.mobile = true;
				}
			},
			settingsFlatsCardModal() {
				var _self = this;
				if ($(window).width() > 1024) {
					_self.modalWidth = 1000;
					_self.modalHeight = 640;
					_self.transitionName = 'pop-out';
				} else {
					_self.modalWidth = 100;
					_self.modalHeight = 'auto';
					_self.modalScroll = true;
					_self.transitionName = 'fade-enter';
				}
			},
			handleResize() {
                var _self = this;
                if (window.innerWidth >= 768 && window.innerWidth >= 1024) {
                    _self.modalWidth = 1000;
					_self.modalHeight = 640;
                } else {
					_self.modalScroll = true;
					_self.modalHeight = 'auto';
				}
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
			customPaginationSwiper() {
				var _self = this;
				setTimeout(()=>{
					const count = document.querySelectorAll("#FlatSwiperCard .swiper-slide").length;
					this.countIndex = count;
					if(count >= 3) {
						this.swiperActiveIndex = 3;
					} else {
						this.swiperActiveIndex = this.$refs.FlatSwiperCard.swiper.activeIndex + 2;
					}
				},50);
				this.$refs.FlatSwiperCard.swiper.on('observerUpdate', function() {
					setTimeout(()=>{
						const count = document.querySelectorAll("#FlatSwiperCard .swiper-slide").length;
						_self.countIndex = count;
						if(count >= 3) {
							_self.swiperActiveIndex = 3;
						} else {
							_self.swiperActiveIndex = _self.$refs.FlatSwiperCard.swiper.activeIndex + 2;
						}
					},50);
				});
			},
			changeActiveIndex() {
				setTimeout(()=>{
					this.swiperActiveIndex = this.$refs.FlatSwiperCard.swiper.activeIndex + 3;
				},50);
			},
		},
		beforeCreate() {
			// this.$store.dispatch('getFlatsCards');
		},
		mounted() {
			this.$store.watch(
				(state) => state.salesCardContentFlatsDefault,
				(newValue) => {
					if (newValue != null) {
						this.PushAllCards();
						this.settingsFlatsCardModal();
                        this.checkMobileDevices();
						this.checkResize();
						// this.customPaginationSwiper();
					}
				}
			)
			// this.$store.watch(
			// 	(state) => state.flatCards,
			// 	(newValue) => {
			// 		if (newValue != null) {
			// 			console.log(newValue)
			// 		}
			// 	}
			// )
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/styles/components/sales/sales-land-partials/land-flats-cards.scss';
	// @import '@/styles/components/animation/animation-flat.scss';
</style>